import {Component, OnInit} from '@angular/core';
import {DialogService} from '../../../../services/dialog.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {

  msg = {
    title: '',
    body: '',
    type: '',
    additionalInfo: '',
    buttons: {ok: '', cancel: ''}
  };
  showWhiteDialog = false;
  openDialog = false;

  constructor(private dialogService: DialogService) {
    this.dialogService.openDialog$.subscribe((res) => {
      this.showWhiteDialog = this.dialogService.showWhiteDialog;
      this.openDialog = (res) ? true : false;
      Object.assign(this.msg, this.dialogService.dialogProperties);
    });
  }

  ngOnInit(): void {
  }

  closeDialog(result: boolean, evt: MouseEvent): void {
    // If only one button then ok button is clicked then its alert box
    evt.preventDefault();
    evt.stopPropagation();
    if (this.msg.type === 'alert') {
      this.dialogService.hideDialog();
    } else {
      this.dialogService.dialogClickAction(result);
    }
  }

}
